import { defineStore } from 'pinia'
import { ref } from 'vue'
import { fetchPublicSettings } from '@/api/endpoints'

export const useSettingsStore = defineStore('settings', () => {
  const dashboardTitle = ref('SmartHome')
  const tablePageSize = ref(25)
  const loaded = ref(false)

  async function loadPublicSettings() {
    try {
      const settings = await fetchPublicSettings()
      dashboardTitle.value = settings.dashboard_title ?? 'SmartHome'
      const pageSizeParsed = parseInt(settings.table_page_size ?? '', 10)
      if (pageSizeParsed > 0) tablePageSize.value = pageSizeParsed
      loaded.value = true
    } catch {
      // Keep defaults on error
    }
  }

  return { dashboardTitle, tablePageSize, loaded, loadPublicSettings }
})
